import { Injectable } from '@angular/core'
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http'
import { Observable } from 'rxjs'
import { tap } from 'rxjs/operators'
import { NzMessageService } from 'ng-zorro-antd/message'
import { TranslateService } from '@ngx-translate/core'
import { VssAuthService, VssUiConfig } from 'projects/vss-ui/src/public-api'
import { AuthService } from '@app/service/auth.service'

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {

  constructor(
    private message: NzMessageService,
    private vssAuthService: VssAuthService,
    private vssConfig: VssUiConfig,
    private translate: TranslateService,
     private authService: AuthService,
  ) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    let newReq: HttpRequest<any> = request.clone();
    if (localStorage.getItem('ticket')) {
      newReq = this.setHeader(newReq);
    }
    const clonedRequest = newReq.clone({
      setHeaders: {
        // 'Current-Language': this.getCurrentLanguageCode(),
        'Accept-Language': this.getCurrentLanguageCode(),
        // 'accessToken':  JSON.parse(JSON.stringify(localStorage.getItem('ticket')))?.accessToken
      }
    });
    return next.handle(clonedRequest).pipe(
      tap(
        event => {
          if (event instanceof HttpResponse) {
            if (event.status !== 200) {
              return
            }
          }
        },
        async e => {
          if (e.status === 401) {
            // Do later: set currentUrl when redirect from SSO
            // localStorage.clear();
            this.vssAuthService.logout()
          } else if (e.status === 0) {
            this.message.error(this.translate.instant('BASE.INTERCEPTOR.NO_CONNECT'))
            return ''
          }
          const error = e?.error
          if (error?.message) {
            this.message.error(error?.message)
          } else if (error?.data && Object.keys(error?.data)?.length) {
            let isHasMessage = false
            Object.keys(error?.data).forEach(
              k => {
                if(error?.data[k] && typeof error?.data[k] == 'string') {
                  isHasMessage = true
                  this.message.error(`${this.vssConfig.mapKeyApiError[k] ? this.vssConfig.mapKeyApiError[k] + ': ' : ''}${error?.data[k]}`)
                }
              }
            )
            if(!isHasMessage) {
              this.message.error(this.translate.instant('BASE.INTERCEPTOR.SYSTEM_ERROR'))
            }
          } else {
            if (e.error instanceof Blob) {
              const jsonError = await (new Response(e.error)).json()
              if (jsonError?.code === 'skip') return
              this.message.error(jsonError.message)
              return

            }
            this.message.error(this.translate.instant('BASE.INTERCEPTOR.SYSTEM_ERROR'))
          }
          return ''
        }
      )
    )
  }

  getCurrentLanguageCode(): string {
    const selectedLang = localStorage.getItem('language');
    if (selectedLang == null) {
      return 'vi-VN';
    } else {
      return selectedLang;
    }
  }

  setHeader(request: HttpRequest<any>): HttpRequest<any> {
    return request.clone({
      headers: request.headers.set(
        'Authorization',
        `Bearer ${JSON.parse(localStorage.getItem('ticket') as any)?.accessToken}`
      )
    })
  }
}
